import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const BuyerAuthContext = createContext(null);

const API_URL = process.env.REACT_APP_API_URL || '/api';

export const BuyerAuthProvider = ({ children }) => {
  const [buyer, setBuyer] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('buyerToken'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchBuyer();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchBuyer = async () => {
    try {
      const response = await axios.get(`${API_URL}/buyer/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBuyer(response.data.buyer);
    } catch (error) {
      logout();
    } finally {
      setLoading(false);
    }
  };

  const loginWithOtp = async (data) => {
    const response = await axios.post(`${API_URL}/buyer/verify-otp`, data);
    const { token: newToken, buyer: buyerData } = response.data;
    localStorage.setItem('buyerToken', newToken);
    setToken(newToken);
    setBuyer(buyerData);
    return buyerData;
  };

  // MSG91 widget path: we hand the backend the widget's access-token and it
  // hands back the same session shape the old OTP form produces.
  const loginWithAccessToken = async (accessToken) => {
    const response = await axios.post(`${API_URL}/buyer/otp-login`, { accessToken });
    const { token: newToken, buyer: buyerData } = response.data;
    localStorage.setItem('buyerToken', newToken);
    setToken(newToken);
    setBuyer(buyerData);
    return buyerData;
  };

  const logout = () => {
    localStorage.removeItem('buyerToken');
    setToken(null);
    setBuyer(null);
  };

  const getAuthHeader = () => token ? { Authorization: `Bearer ${token}` } : {};
  const refreshBuyer = fetchBuyer;

  return (
    <BuyerAuthContext.Provider value={{ buyer, token, loginWithOtp, loginWithAccessToken, logout, loading, getAuthHeader, API_URL, refreshBuyer }}>
      {children}
    </BuyerAuthContext.Provider>
  );
};

export const useBuyerAuth = () => {
  const context = useContext(BuyerAuthContext);
  if (!context) throw new Error('useBuyerAuth must be used within BuyerAuthProvider');
  return context;
};
